function isObjectValuesEmpty(obj) {
  return Object.values(obj).reduce((acc, value) => {
    if (value) acc = false;
    return acc;
  }, true);
}

export { isObjectValuesEmpty };
